<template>  
<div class="enhelpList" id="enhelpList">
    <div class="banner">
        <img :src="list1.logo" alt="">
        <div class="des">
             <div class="title">{{list1.title1}}</div>
        <div class="titles">{{list1.title1s}}</div>
        <el-input
            placeholder="请输入您遇到的问题或产品名称：如“边缘计算站”"
            v-model="serch"
             @keyup.enter.native="getInfo"
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="getInfo"></i>
        </el-input>
        </div>
    </div>
    <!-- 移动端 -->
     <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-gallery-view"></i>
                <h1>{{list1.title1}}</h1>
                <h3>{{list1.title1s}}</h3>
                    <div class="endowloadDetail-description-search flex align-cen">
                       <el-input
                 placeholder="请输入您遇到的问题或产品名称：如“边缘计算站”"
                clearable
                v-model="serch">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  <template slot="append">
                    <div class="append-click" @click="getInfo">立即搜索</div>
                  </template>
            </el-input>
                </div>
            </div>
        </div>
    <div class="enhelp-content">
        <div class="enhelp-content-wrap">
            <h3>按照产品学习</h3>
            <p class="wrap-p">根据和隆优化产品分类学习文档</p>
            <ul class="enhelp-content-wrap-ul flex align-cen">
                <li v-for="(item,index) in list" :key="item.id" class="enhelp-content-wrap-li">
                    <img :src="item.logo ? item.logo : require('../../assets/images/enfm.png')" alt="" class="titlogo">
                    <div class="li-tit flex align-cen">
                       <div class="tit-left flex align-cen">
                          <img src="../../assets/images/enicon.png" alt="">
                       <p> {{item.title}}</p>
                       </div>
                       <div class="mft" @click="openDetail(item.id)">
                        查找全部 <i class="icon-al-angle-right"></i>
                       </div>
                        </div>
                     <div class="childrenlist" v-if="item.chapterTileList.length>0">
                        <div  v-for="(childItem,childIndex) in item.chapterTileList" :key="childIndex" @click="openDetail(item.id)">
                            <p v-if="childIndex <=3">
                                <i class="icon-al-news"></i>
                                {{childItem}}
                                </p>
                        </div>
                     </div>
                      <div class="childrenlist" v-else>
                        <p class="nop">暂无帮助</p>
                     </div>
                </li>
            </ul>
        </div>
    </div>
    <goTop></goTop>
</div>
</template>
<script>
import { frontList,softList} from "@/api/enterprise/index" // 查询帮助列表、详情
import goTop from '@/components/goTop'
    export default {
        name: "enhelpList",
        components: {
            goTop
        },
        data(){
            return {
                list1:{
                logo:'',
                title1:'',
                title1s:'',
            },
                serch:'',
                list:[],
                isImg:require('../../assets/images/banner.png')
            }
        },
        created() {
         document.title = "帮助中心"
         let token1 = localStorage.getItem('token1');
         this.getDetail()
          this.getInfo()
        //  if(token1){
           
        //  }else{
        //    this.$router.replace({
        //     name:'enLogin',
        //     query: {
        //         redirectUrl:'enhelpList' 
        //     }
        //    })
        //  }
        },
        mounted() {
             if (this._isMobile()) {
                this.isImg = require('../../assets/images/banner1.jpg')
                } else {
                 this.isImg = require('../../assets/images/banner.png')
                }
        },
        computed: {
        },

        watch: {},
        methods: {
            // 区分设备

                _isMobile() {
                    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                    return flag;
                },
            // 打开详情
            openDetail(id){
                 const newurl = this.$router.resolve({name:'enhelpdetail', query: {id:id,type:1}})
             window.open(newurl.href,'_blank')
                // this.$router.push({
                //     name:'enhelpdetail',
                //     query: {
                //         id:id,
                //         type:1
                //     }
                // })
            },
            // search(){
            //     alert(1)
            // },
            getInfo(){
            frontList({
                title:this.serch,
                officialType:2
            },'enterprise')
            .then(res => {
             this.list = res.data
            })
            .catch(err => {
            })
            },
            getDetail(){
                   softList({id:4},'enterprise')
                .then(res => {
                 res.data.forEach(item =>{
                     if(item.attributeName == "logo")   this.list1.logo  = item.attributeValue
                    if(item.attributeName == "title1")  this.list1.title1  = item.attributeValue
                    if(item.attributeName == "title1s") this.list1.title1s  = item.attributeValue
                 })
                })
                .catch(err => {                  
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
.enhelpList{
    width: 100%;
     .item-gradient{
        display: none;
    }
    .banner{
        width: 100%;
    //      background: url('~@/assets/images/banner.png') no-repeat 0 0;
    // background-size: cover;
    // height: 360px;
    position: relative;
     .des{
        position: absolute;
        top: 30%;
        left: 50%;
        margin-left: -330px;
        .title{color: #fff;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        }
        .titles{
            color: #fff;
              text-align: center;
              padding-bottom: 30px;
              padding-top: 10px;
        }
     }
    }
    .enhelp-content{
        width: 1200px;
        margin: 0 auto;
        
        .enhelp-content-wrap{
            margin-top: 60px;
            padding-bottom: 60px;
            h3{
                height: 23px;
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
                padding-bottom: 10px;
            }
            p{
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
            }
            ul{
                flex-wrap: wrap;
                li{
                    width: 371px;
                    height: 306px;
                    background: #FFFFFF80;
                    border: 1px solid #E0E0E0;
                    border-radius: 10px;
                    margin-top: 30px;
                    margin-right: 25px;
                    .titlogo{
                        width: 100%;
                        height: 130px;
                    }
                    .li-tit{
                        padding:21px;
                        padding-bottom: 10px;
                        .tit-left{
                        width: 250px;
                            p{
                                color: #333;
                                font-size: 16px;
                                padding-left: 10px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            img{
                                width: 30px;
                            }
                        }
                        .mft{
                            color: #518EFC;
                            font-size: 14px;
                            cursor: pointer;
                            i{
                                font-size: 12px;
                            }
                        }
                    }
                    .childrenlist{
                        padding: 0 21px;
                        p{
                            cursor: pointer;
                            padding-left: 15px;
                            i{
                                padding-right: 10px;
                                  font-size: 12px;
                                  color: #333;
                            }
                            font-size: 14px;
                            color: #333;
                           line-height: 25px
                        }
                        .nop{
                            text-align: center;
                            padding-top: 30px;
                            padding-left: 0;
                        }
                    }
                }
            }
        }
    }
}
::v-deep{
     .el-input {
         width: 660px;
        .el-input__inner{
        height: 44px;
        background: rgba(255,255,255,0.2000);
        border: 1px solid #FFFFFF;
        border-radius: 22px;
        color: #fff;
        }
        i{
            color: #fff;
        }
    }
    ::-webkit-input-placeholder { 
/* WebKit browsers，webkit内核浏览器 */
color: #fff; 
font-size: 14px;
}
@media (max-width: 640px){
     .el-input {
         width: 100%;
         i{
    color: #ccc !important;
}
     }
        ::-webkit-input-placeholder { 
/* WebKit browsers，webkit内核浏览器 */
color: #ccc; 
font-size: 14px;
}
    .el-input__inner{
        border: 1px solid #ccc !important;
border-radius: 20px 0 0 20px !important;
border-right: none !important;
color: #333 !important;
box-sizing: border-box;

    }
 .el-input-group__append{
border: 1px solid #E6E6E6;
border-radius: 0 20px 20px 0;
background: #2F54EB;
color: #fff;
padding: 0 30px;
cursor: pointer;
 }
}
}
@media (max-width: 640px){
           .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          .endowloadDetail-description-search{
            margin-top: 20px;
          }
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        .icon-al-gallery-view{
            color: #000;
            font-size: 40px;
        }
       }
    }
   .enhelpList{
    .des{display: none;}
    .banner{
        width: 100%;
         .el-input{
        width: 250px;
        position: absolute;
       bottom: 5px;
        left: 50%;
        margin-left: -125px;

        .el-input {
            .el-input__inner {
            height: 30px !important;
            .el-input__prefix{
                top: -5px;
            }
        }
        }
     }
    }
     .enhelp-content{
        width: 100%;
        h3,p{
            padding-left: 21px;
        }
        ul{
            li{
                margin: 0 auto;
                margin-right: auto !important;
            }
        }
     }
   }
}
</style>
